<template>
  <a
    v-if="display"
    target="_blank"
    rel="noopener noreferrer"
    class="support"
    :href="supportUrl"
    :aria-label="`${$t('global.support')} ${$t('global.new_window')}`"
    v-tooltip="{ title: $t('global.support') }"
    :title="$t('global.support')"
  >
    <img src="/assets/images/icone-support.png" :alt="$t('global.support')" @error="imageError = true" />
    <span v-if="imageError" class="support-fallback">?</span>
  </a>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore } from "@/store/user/user";

export default {
  name: "SupportComponent",
  data() {
    return {
      supportUrl: "https://studea.support.effetb.com/",
      imageError: false,
    };
  },
  computed: {
    display() {
      return this.user && (this.user.isStudeaManager || this.user.isAdmin);
    },

    ...mapState(useUserStore, {
      user: (store) => store.user,
    }),
  },
};
</script>

<style lang="scss" scoped>
.support {
  position: fixed;
  right: 0;
  bottom: 100px;
  background: $white;
  color: $black;
  z-index: 1000;
  width: 60px;
  height: 60px;
  padding: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 5px 15px;
  border-radius: $radius 0 0 $radius;
  border: 2px solid $grey;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  &:hover,
  &:focus {
    border-color: $dark-grey;
    outline: 2px solid $primary;
    outline-offset: 2px;
  }

  &:focus-visible {
    outline: 2px solid $primary;
    outline-offset: 2px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .support-fallback {
    font-size: 24px;
    font-weight: bold;
    color: $primary;
    line-height: 1;
  }
}
.supportIframe {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
</style>
